module.exports = __webpack_public_path__ + "static/media/material_icon_contract.6b2cfb07.svg";